import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/fixed-distributions.js';
import { caseVouchersEntity } from '../case-vouchers/index.js';
import q from '../query.js';
export const fixedDistributionsEntity = 'fixed-distributions';
export const useFixedDistributionsByCaseId = (caseId) => q.query(`fixed-distributions-by-case-${caseId}`, () => api.getByCaseId(caseId), [
    ...keys.read.collection(fixedDistributionsEntity),
    ...keys.read.collection(caseVouchersEntity),
], { enabled: caseId != null });
//# sourceMappingURL=index.js.map